var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 744,
    height: 727,
    viewBox: "0 0 744 727",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.157 167.942H242.771V162.466C221.167 164.605 199.991 164.22 174.601 166.38C174.865 166.869 175.052 167.396 175.157 167.942Z",
    fill: "url(#paint0_linear_2067_17058)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M737.548 306.101C727.195 247.962 698.703 202.273 662.083 160.049C657.891 155.215 653.748 150.623 649.656 146.273H540.758C540.402 147.22 539.8 148.053 539.013 148.688C538.227 149.323 537.285 149.737 536.285 149.885C535.285 150.034 534.264 149.912 533.327 149.533C532.39 149.154 531.571 148.531 530.956 147.729C530.34 146.928 529.95 145.976 529.827 144.973C529.703 143.969 529.85 142.951 530.252 142.024C530.654 141.096 531.296 140.293 532.113 139.698C532.93 139.102 533.891 138.736 534.897 138.637V113.589H471.753V146.316H397.23V205.567H395.091V144.177H469.614V111.45H587.581C587.847 110.059 588.623 108.818 589.755 107.968C590.888 107.118 592.297 106.722 593.707 106.855C595.116 106.989 596.426 107.644 597.379 108.691C598.331 109.738 598.859 111.104 598.859 112.52C598.859 113.936 598.331 115.301 597.379 116.348C596.426 117.396 595.116 118.05 593.707 118.184C592.297 118.318 590.888 117.921 589.755 117.071C588.623 116.222 587.847 114.98 587.581 113.589H537.079V138.808C538.233 139.147 539.251 139.843 539.985 140.796C540.719 141.749 541.132 142.91 541.164 144.113H647.538C567.047 59.5789 501.742 60.2848 450.299 73.1403C400.053 85.7177 376.246 114.231 321.551 139.985V150.68H367.818V152.819H319.412V141.033C315.455 142.851 311.37 144.648 307.091 146.445C287.278 154.81 266.314 160.132 244.91 162.231V170.059H175.157C174.884 171.444 174.107 172.678 172.976 173.522C171.845 174.366 170.441 174.759 169.036 174.626C167.632 174.493 166.326 173.842 165.374 172.801C164.422 171.759 163.891 170.401 163.884 168.99C163.888 168.436 163.982 167.887 164.162 167.364C151 168.838 137.92 170.979 124.975 173.781C45.5962 190.893 0.462891 298.144 0.462891 359.47C0.462891 420.795 5.2329 509.436 73.6174 555.382C142.002 601.329 303.99 514.42 367.797 517.864C431.604 521.308 504.694 592.73 596.672 592.73C725.27 592.73 758.767 425.651 737.548 306.101ZM652.586 372.731H686.81V315.748C685.42 315.482 684.178 314.707 683.328 313.574C682.479 312.441 682.082 311.032 682.215 309.622C682.349 308.213 683.004 306.904 684.051 305.951C685.099 304.998 686.464 304.47 687.88 304.47C689.296 304.47 690.661 304.998 691.709 305.951C692.756 306.904 693.411 308.213 693.544 309.622C693.678 311.032 693.281 312.441 692.431 313.574C691.582 314.707 690.34 315.482 688.949 315.748V374.913H654.725V413.052H652.586V372.731ZM529.058 254.187H600.651C600.917 252.796 601.692 251.555 602.825 250.705C603.958 249.855 605.366 249.458 606.776 249.592C608.186 249.726 609.495 250.38 610.448 251.428C611.401 252.475 611.929 253.84 611.929 255.256C611.929 256.673 611.401 258.038 610.448 259.085C609.495 260.133 608.186 260.787 606.776 260.921C605.366 261.055 603.958 260.658 602.825 259.808C601.692 258.958 600.917 257.717 600.651 256.326H528.993L529.058 254.187ZM145.852 249.567C147.266 249.578 148.625 250.117 149.662 251.079C150.699 252.041 151.339 253.355 151.456 254.765H257.274V256.904H151.221C150.938 257.926 150.374 258.849 149.594 259.568C148.814 260.288 147.848 260.774 146.805 260.973C145.763 261.173 144.686 261.076 143.695 260.695C142.705 260.314 141.841 259.664 141.2 258.818C140.56 257.972 140.169 256.963 140.072 255.907C139.975 254.85 140.175 253.787 140.65 252.838C141.125 251.889 141.855 251.092 142.76 250.537C143.664 249.981 144.705 249.69 145.767 249.695L145.852 249.567ZM253.167 492.025H217.039V506.998C218.055 507.191 218.999 507.658 219.77 508.347C220.541 509.037 221.109 509.924 221.414 510.913C221.718 511.901 221.747 512.954 221.498 513.958C221.249 514.962 220.731 515.879 219.999 516.611C219.268 517.342 218.351 517.86 217.347 518.11C216.343 518.359 215.29 518.33 214.301 518.025C213.313 517.721 212.426 517.152 211.736 516.382C211.046 515.611 210.58 514.666 210.386 513.65H141.424V477.779H112.013C111.729 478.771 111.182 479.667 110.428 480.371C109.674 481.076 108.743 481.562 107.735 481.779V536.559H73.5104C73.0118 537.883 72.0378 538.974 70.7785 539.618C69.5192 540.263 68.065 540.415 66.6994 540.046C65.3339 539.676 64.1549 538.811 63.3927 537.619C62.6304 536.428 62.3394 534.995 62.5765 533.6C62.8136 532.205 63.5618 530.949 64.675 530.076C65.7883 529.203 67.1868 528.776 68.5978 528.879C70.0088 528.981 71.331 529.605 72.3065 530.63C73.282 531.655 73.8409 533.006 73.8741 534.42H105.553V481.779C104.544 481.562 103.613 481.076 102.86 480.371C102.106 479.667 101.558 478.771 101.275 477.779H57.1255C56.7342 479.145 55.8475 480.317 54.6386 481.064C53.4297 481.812 51.9855 482.081 50.5882 481.821C49.191 481.56 47.9411 480.788 47.0828 479.655C46.2245 478.522 45.8195 477.11 45.9469 475.695C46.0743 474.279 46.7249 472.962 47.7717 472C48.8185 471.039 50.1862 470.502 51.6075 470.495C53.0289 470.489 54.4016 471.012 55.4577 471.963C56.5137 472.915 57.177 474.225 57.318 475.64H100.933C101.081 474.249 101.739 472.962 102.78 472.026C103.82 471.091 105.17 470.574 106.569 470.574C107.968 470.574 109.318 471.091 110.358 472.026C111.399 472.962 112.057 474.249 112.205 475.64H143.563V511.554H210.386C210.601 510.437 211.146 509.409 211.951 508.605C212.755 507.8 213.782 507.255 214.9 507.041V489.928H253.081L253.167 492.025ZM116.141 415.683C115.887 416.977 115.191 418.142 114.173 418.979C113.154 419.817 111.877 420.275 110.558 420.275C109.24 420.275 107.962 419.817 106.944 418.979C105.926 418.142 105.23 416.977 104.975 415.683H86.1093C85.8431 417.074 85.0679 418.315 83.9351 419.165C82.8024 420.015 81.3934 420.412 79.9837 420.278C78.574 420.144 77.2648 419.49 76.312 418.442C75.3591 417.395 74.8311 416.03 74.8311 414.614C74.8311 413.197 75.3591 411.832 76.312 410.785C77.2648 409.737 78.574 409.083 79.9837 408.949C81.3934 408.815 82.8024 409.212 83.9351 410.062C85.0679 410.912 85.8431 412.153 86.1093 413.544H104.975C105.222 412.256 105.906 411.092 106.911 410.25C107.917 409.408 109.183 408.94 110.494 408.924V392.817H61.2966C61.2104 394.235 60.5986 395.57 59.5807 396.562C58.5627 397.553 57.2118 398.13 55.7917 398.178C54.3716 398.227 52.9844 397.744 51.9009 396.825C50.8175 395.906 50.1156 394.616 49.9324 393.207C49.7493 391.798 50.0979 390.371 50.9103 389.205C51.7227 388.039 52.9405 387.218 54.3258 386.902C55.7112 386.586 57.1646 386.798 58.4021 387.496C59.6397 388.194 60.5726 389.329 61.0186 390.678H112.655V409.33C113.551 409.693 114.341 410.274 114.954 411.022C115.567 411.769 115.982 412.658 116.162 413.608H695.345C695.611 412.217 696.386 410.976 697.519 410.126C698.652 409.276 700.061 408.88 701.471 409.013C702.88 409.147 704.19 409.802 705.142 410.849C706.095 411.896 706.623 413.262 706.623 414.678C706.623 416.094 706.095 417.459 705.142 418.506C704.19 419.554 702.88 420.208 701.471 420.342C700.061 420.476 698.652 420.079 697.519 419.229C696.386 418.38 695.611 417.138 695.345 415.747L116.141 415.683ZM696.907 516.452C697.103 515.056 697.814 513.783 698.899 512.882C699.984 511.981 701.366 511.518 702.775 511.581C704.184 511.645 705.518 512.231 706.518 513.226C707.517 514.221 708.11 515.552 708.181 516.961C708.251 518.369 707.794 519.753 706.899 520.843C706.003 521.932 704.734 522.649 703.338 522.853C701.943 523.056 700.522 522.733 699.352 521.945C698.183 521.157 697.349 519.961 697.013 518.591H614.939V496.859C613.917 496.586 612.993 496.03 612.274 495.254C611.554 494.478 611.07 493.514 610.875 492.474H519.689V490.335H610.875C611.13 489.041 611.825 487.876 612.844 487.038C613.862 486.201 615.14 485.743 616.458 485.743C617.776 485.743 619.054 486.201 620.072 487.038C621.091 487.876 621.786 489.041 622.041 490.335H696.907C697.173 488.944 697.948 487.702 699.081 486.853C700.213 486.003 701.622 485.606 703.032 485.74C704.442 485.874 705.751 486.528 706.704 487.576C707.657 488.623 708.185 489.988 708.185 491.404C708.185 492.82 707.657 494.186 706.704 495.233C705.751 496.28 704.442 496.935 703.032 497.069C701.622 497.202 700.213 496.806 699.081 495.956C697.948 495.106 697.173 493.865 696.907 492.474H622.041C621.807 493.663 621.199 494.746 620.306 495.565C619.414 496.385 618.283 496.898 617.078 497.03V516.452H696.907Z",
    fill: "url(#paint1_linear_2067_17058)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.157 167.942H242.771V162.466C221.167 164.605 199.991 164.22 174.601 166.38C174.865 166.869 175.052 167.396 175.157 167.942Z",
    fill: "#455A64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M737.548 306.101C727.195 247.962 698.703 202.273 662.083 160.049C657.891 155.215 653.748 150.623 649.656 146.273H540.758C540.402 147.22 539.8 148.053 539.013 148.688C538.227 149.323 537.285 149.737 536.285 149.885C535.285 150.034 534.264 149.912 533.327 149.533C532.39 149.154 531.571 148.531 530.956 147.729C530.34 146.928 529.95 145.976 529.827 144.973C529.703 143.969 529.85 142.951 530.252 142.024C530.654 141.096 531.296 140.293 532.113 139.698C532.93 139.102 533.891 138.736 534.897 138.637V113.589H471.753V146.316H397.23V205.567H395.091V144.177H469.614V111.45H587.581C587.847 110.059 588.623 108.818 589.755 107.968C590.888 107.118 592.297 106.722 593.707 106.855C595.116 106.989 596.426 107.644 597.379 108.691C598.331 109.738 598.859 111.104 598.859 112.52C598.859 113.936 598.331 115.301 597.379 116.348C596.426 117.396 595.116 118.05 593.707 118.184C592.297 118.318 590.888 117.921 589.755 117.071C588.623 116.222 587.847 114.98 587.581 113.589H537.079V138.808C538.233 139.147 539.251 139.843 539.985 140.796C540.719 141.749 541.132 142.91 541.164 144.113H647.538C567.047 59.5789 501.742 60.2848 450.299 73.1403C400.053 85.7177 376.246 114.231 321.551 139.985V150.68H367.818V152.819H319.412V141.033C315.455 142.851 311.37 144.648 307.091 146.445C287.278 154.81 266.314 160.132 244.91 162.231V170.059H175.157C174.884 171.444 174.107 172.678 172.976 173.522C171.845 174.366 170.441 174.759 169.036 174.626C167.632 174.493 166.326 173.842 165.374 172.801C164.422 171.759 163.891 170.401 163.884 168.99C163.888 168.436 163.982 167.887 164.162 167.364C151 168.838 137.92 170.979 124.975 173.781C45.5962 190.893 0.462891 298.144 0.462891 359.47C0.462891 420.795 5.2329 509.436 73.6174 555.382C142.002 601.329 303.99 514.42 367.797 517.864C431.604 521.308 504.694 592.73 596.672 592.73C725.27 592.73 758.767 425.651 737.548 306.101ZM652.586 372.731H686.81V315.748C685.42 315.482 684.178 314.707 683.328 313.574C682.479 312.441 682.082 311.032 682.215 309.622C682.349 308.213 683.004 306.904 684.051 305.951C685.099 304.998 686.464 304.47 687.88 304.47C689.296 304.47 690.661 304.998 691.709 305.951C692.756 306.904 693.411 308.213 693.544 309.622C693.678 311.032 693.281 312.441 692.431 313.574C691.582 314.707 690.34 315.482 688.949 315.748V374.913H654.725V413.052H652.586V372.731ZM529.058 254.187H600.651C600.917 252.796 601.692 251.555 602.825 250.705C603.958 249.855 605.366 249.458 606.776 249.592C608.186 249.726 609.495 250.38 610.448 251.428C611.401 252.475 611.929 253.84 611.929 255.256C611.929 256.673 611.401 258.038 610.448 259.085C609.495 260.133 608.186 260.787 606.776 260.921C605.366 261.055 603.958 260.658 602.825 259.808C601.692 258.958 600.917 257.717 600.651 256.326H528.993L529.058 254.187ZM145.852 249.567C147.266 249.578 148.625 250.117 149.662 251.079C150.699 252.041 151.339 253.355 151.456 254.765H257.274V256.904H151.221C150.938 257.926 150.374 258.849 149.594 259.568C148.814 260.288 147.848 260.774 146.805 260.973C145.763 261.173 144.686 261.076 143.695 260.695C142.705 260.314 141.841 259.664 141.2 258.818C140.56 257.972 140.169 256.963 140.072 255.907C139.975 254.85 140.175 253.787 140.65 252.838C141.125 251.889 141.855 251.092 142.76 250.537C143.664 249.981 144.705 249.69 145.767 249.695L145.852 249.567ZM253.167 492.025H217.039V506.998C218.055 507.191 218.999 507.658 219.77 508.347C220.541 509.037 221.109 509.924 221.414 510.913C221.718 511.901 221.747 512.954 221.498 513.958C221.249 514.962 220.731 515.879 219.999 516.611C219.268 517.342 218.351 517.86 217.347 518.11C216.343 518.359 215.29 518.33 214.301 518.025C213.313 517.721 212.426 517.152 211.736 516.382C211.046 515.611 210.58 514.666 210.386 513.65H141.424V477.779H112.013C111.729 478.771 111.182 479.667 110.428 480.371C109.674 481.076 108.743 481.562 107.735 481.779V536.559H73.5104C73.0118 537.883 72.0378 538.974 70.7785 539.618C69.5192 540.263 68.065 540.415 66.6994 540.046C65.3339 539.676 64.1549 538.811 63.3927 537.619C62.6304 536.428 62.3394 534.995 62.5765 533.6C62.8136 532.205 63.5618 530.949 64.675 530.076C65.7883 529.203 67.1868 528.776 68.5978 528.879C70.0088 528.981 71.331 529.605 72.3065 530.63C73.282 531.655 73.8409 533.006 73.8741 534.42H105.553V481.779C104.544 481.562 103.613 481.076 102.86 480.371C102.106 479.667 101.558 478.771 101.275 477.779H57.1255C56.7342 479.145 55.8475 480.317 54.6386 481.064C53.4297 481.812 51.9855 482.081 50.5882 481.821C49.191 481.56 47.9411 480.788 47.0828 479.655C46.2245 478.522 45.8195 477.11 45.9469 475.695C46.0743 474.279 46.7249 472.962 47.7717 472C48.8185 471.039 50.1862 470.502 51.6075 470.495C53.0289 470.489 54.4016 471.012 55.4577 471.963C56.5137 472.915 57.177 474.225 57.318 475.64H100.933C101.081 474.249 101.739 472.962 102.78 472.026C103.82 471.091 105.17 470.574 106.569 470.574C107.968 470.574 109.318 471.091 110.358 472.026C111.399 472.962 112.057 474.249 112.205 475.64H143.563V511.554H210.386C210.601 510.437 211.146 509.409 211.951 508.605C212.755 507.8 213.782 507.255 214.9 507.041V489.928H253.081L253.167 492.025ZM116.141 415.683C115.887 416.977 115.191 418.142 114.173 418.979C113.154 419.817 111.877 420.275 110.558 420.275C109.24 420.275 107.962 419.817 106.944 418.979C105.926 418.142 105.23 416.977 104.975 415.683H86.1093C85.8431 417.074 85.0679 418.315 83.9351 419.165C82.8024 420.015 81.3934 420.412 79.9837 420.278C78.574 420.144 77.2648 419.49 76.312 418.442C75.3591 417.395 74.8311 416.03 74.8311 414.614C74.8311 413.197 75.3591 411.832 76.312 410.785C77.2648 409.737 78.574 409.083 79.9837 408.949C81.3934 408.815 82.8024 409.212 83.9351 410.062C85.0679 410.912 85.8431 412.153 86.1093 413.544H104.975C105.222 412.256 105.906 411.092 106.911 410.25C107.917 409.408 109.183 408.94 110.494 408.924V392.817H61.2966C61.2104 394.235 60.5986 395.57 59.5807 396.562C58.5627 397.553 57.2118 398.13 55.7917 398.178C54.3716 398.227 52.9844 397.744 51.9009 396.825C50.8175 395.906 50.1156 394.616 49.9324 393.207C49.7493 391.798 50.0979 390.371 50.9103 389.205C51.7227 388.039 52.9405 387.218 54.3258 386.902C55.7112 386.586 57.1646 386.798 58.4021 387.496C59.6397 388.194 60.5726 389.329 61.0186 390.678H112.655V409.33C113.551 409.693 114.341 410.274 114.954 411.022C115.567 411.769 115.982 412.658 116.162 413.608H695.345C695.611 412.217 696.386 410.976 697.519 410.126C698.652 409.276 700.061 408.88 701.471 409.013C702.88 409.147 704.19 409.802 705.142 410.849C706.095 411.896 706.623 413.262 706.623 414.678C706.623 416.094 706.095 417.459 705.142 418.506C704.19 419.554 702.88 420.208 701.471 420.342C700.061 420.476 698.652 420.079 697.519 419.229C696.386 418.38 695.611 417.138 695.345 415.747L116.141 415.683ZM696.907 516.452C697.103 515.056 697.814 513.783 698.899 512.882C699.984 511.981 701.366 511.518 702.775 511.581C704.184 511.645 705.518 512.231 706.518 513.226C707.517 514.221 708.11 515.552 708.181 516.961C708.251 518.369 707.794 519.753 706.899 520.843C706.003 521.932 704.734 522.649 703.338 522.853C701.943 523.056 700.522 522.733 699.352 521.945C698.183 521.157 697.349 519.961 697.013 518.591H614.939V496.859C613.917 496.586 612.993 496.03 612.274 495.254C611.554 494.478 611.07 493.514 610.875 492.474H519.689V490.335H610.875C611.13 489.041 611.825 487.876 612.844 487.038C613.862 486.201 615.14 485.743 616.458 485.743C617.776 485.743 619.054 486.201 620.072 487.038C621.091 487.876 621.786 489.041 622.041 490.335H696.907C697.173 488.944 697.948 487.702 699.081 486.853C700.213 486.003 701.622 485.606 703.032 485.74C704.442 485.874 705.751 486.528 706.704 487.576C707.657 488.623 708.185 489.988 708.185 491.404C708.185 492.82 707.657 494.186 706.704 495.233C705.751 496.28 704.442 496.935 703.032 497.069C701.622 497.202 700.213 496.806 699.081 495.956C697.948 495.106 697.173 493.865 696.907 492.474H622.041C621.807 493.663 621.199 494.746 620.306 495.565C619.414 496.385 618.283 496.898 617.078 497.03V516.452H696.907Z",
    fill: "#1E2328"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M420.502 113.097H366.278C365.085 113.097 363.94 112.625 363.094 111.783C362.248 110.941 361.77 109.799 361.765 108.605V83.0654C361.765 74.6806 365.095 66.6393 371.024 60.7104C376.953 54.7815 384.995 51.4506 393.379 51.4506C401.764 51.4506 409.805 54.7815 415.734 60.7104C421.663 66.6393 424.994 74.6806 424.994 83.0654V108.605C424.994 109.797 424.521 110.939 423.678 111.782C422.836 112.624 421.693 113.097 420.502 113.097ZM370.791 104.092H415.989V83.0654C416.082 80.0391 415.566 77.0251 414.472 74.2019C413.379 71.3787 411.729 68.804 409.621 66.6305C407.514 64.4569 404.991 62.7289 402.203 61.5488C399.415 60.3687 396.418 59.7606 393.39 59.7606C390.362 59.7606 387.366 60.3687 384.577 61.5488C381.789 62.7289 379.266 64.4569 377.159 66.6305C375.051 68.804 373.401 71.3787 372.308 74.2019C371.214 77.0251 370.698 80.0391 370.791 83.0654V104.092Z",
    fill: "url(#paint2_linear_2067_17058)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M427.454 100.798H358.428V159.129H427.454V100.798Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M400.117 125.011C400.123 123.678 399.774 122.367 399.106 121.213C398.439 120.059 397.477 119.102 396.319 118.442C395.161 117.781 393.848 117.44 392.515 117.453C391.182 117.466 389.876 117.832 388.731 118.515C387.586 119.198 386.642 120.173 385.998 121.34C385.353 122.507 385.029 123.825 385.061 125.158C385.092 126.491 385.476 127.791 386.175 128.927C386.874 130.063 387.861 130.992 389.037 131.621L387.775 144.883H397.443L396.181 131.621C397.374 130.979 398.37 130.024 399.063 128.86C399.756 127.696 400.121 126.366 400.117 125.011Z",
    fill: "url(#paint3_linear_2067_17058)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M672.885 401.031H618.661C618.069 401.031 617.483 400.914 616.937 400.687C616.39 400.46 615.894 400.127 615.477 399.708C615.06 399.288 614.729 398.79 614.505 398.243C614.28 397.696 614.166 397.109 614.169 396.517V370.999C614.059 366.779 614.795 362.581 616.334 358.65C617.873 354.72 620.183 351.137 623.129 348.114C626.075 345.091 629.596 342.688 633.485 341.048C637.374 339.407 641.552 338.562 645.773 338.562C649.994 338.562 654.172 339.407 658.061 341.048C661.95 342.688 665.471 345.091 668.417 348.114C671.362 351.137 673.673 354.72 675.212 358.65C676.75 362.581 677.487 366.779 677.377 370.999V396.517C677.38 397.109 677.266 397.696 677.041 398.243C676.817 398.79 676.486 399.288 676.069 399.708C675.651 400.127 675.155 400.46 674.609 400.687C674.063 400.914 673.477 401.031 672.885 401.031ZM623.174 392.025H668.372V370.999C668.465 367.973 667.949 364.959 666.855 362.135C665.762 359.312 664.112 356.738 662.004 354.564C659.896 352.39 657.374 350.662 654.586 349.482C651.797 348.302 648.801 347.694 645.773 347.694C642.745 347.694 639.748 348.302 636.96 349.482C634.172 350.662 631.649 352.39 629.542 354.564C627.434 356.738 625.784 359.312 624.69 362.135C623.597 364.959 623.081 367.973 623.174 370.999V392.025Z",
    fill: "url(#paint4_linear_2067_17058)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M679.837 388.731H610.811V447.063H679.837V388.731Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M652.5 413.052C652.505 411.719 652.156 410.408 651.489 409.254C650.822 408.099 649.86 407.143 648.702 406.482C647.544 405.822 646.231 405.48 644.898 405.493C643.564 405.506 642.259 405.873 641.113 406.556C639.968 407.239 639.025 408.214 638.38 409.381C637.736 410.548 637.412 411.865 637.443 413.198C637.475 414.531 637.859 415.832 638.558 416.967C639.257 418.103 640.244 419.033 641.42 419.662L640.158 432.902H649.848L648.564 419.469C649.727 418.841 650.703 417.916 651.394 416.79C652.086 415.663 652.467 414.373 652.5 413.052Z",
    fill: "url(#paint5_linear_2067_17058)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.082 401.031H110.815C110.221 401.034 109.633 400.919 109.084 400.693C108.535 400.467 108.037 400.135 107.617 399.715C107.197 399.295 106.865 398.797 106.639 398.248C106.413 397.699 106.298 397.111 106.301 396.517V370.999C106.301 362.614 109.632 354.573 115.561 348.644C121.49 342.715 129.531 339.384 137.916 339.384C146.301 339.384 154.342 342.715 160.271 348.644C166.2 354.573 169.531 362.614 169.531 370.999V396.517C169.536 397.705 169.072 398.847 168.238 399.692C167.404 400.538 166.269 401.019 165.082 401.031ZM115.371 392.025H160.59V370.999C160.59 365.002 158.208 359.252 153.968 355.012C149.727 350.771 143.977 348.389 137.98 348.389C131.984 348.389 126.233 350.771 121.993 355.012C117.753 359.252 115.371 365.002 115.371 370.999V392.025Z",
    fill: "url(#paint6_linear_2067_17058)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.055 388.731H103.029V447.063H172.055V388.731Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.718 413.052C144.722 411.72 144.372 410.411 143.704 409.259C143.036 408.107 142.075 407.152 140.918 406.492C139.761 405.833 138.45 405.492 137.118 405.505C135.786 405.517 134.482 405.883 133.337 406.564C132.193 407.245 131.25 408.218 130.604 409.383C129.958 410.548 129.633 411.863 129.661 413.194C129.69 414.526 130.071 415.826 130.766 416.962C131.461 418.098 132.444 419.03 133.617 419.662L132.355 432.902H142.023L140.761 419.469C141.929 418.845 142.911 417.922 143.606 416.795C144.302 415.668 144.685 414.376 144.718 413.052Z",
    fill: "url(#paint7_linear_2067_17058)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M714.575 359.577C706.019 368.518 700.928 382.207 701.013 396.132C701.099 410.057 706.468 423.94 715.345 432.795C716.023 433.473 716.942 433.854 717.901 433.854C718.86 433.854 719.779 433.473 720.457 432.795C720.796 432.46 721.063 432.06 721.244 431.619C721.424 431.178 721.513 430.705 721.505 430.228C721.498 429.276 721.123 428.364 720.457 427.683C712.885 420.175 708.329 408.432 708.243 396.111C708.158 383.79 712.521 372.218 719.794 364.603C720.123 364.261 720.38 363.856 720.553 363.414C720.725 362.972 720.809 362.5 720.799 362.025C720.789 361.55 720.686 361.082 720.495 360.647C720.304 360.213 720.03 359.82 719.687 359.491C719.344 359.162 718.94 358.904 718.498 358.732C718.055 358.559 717.583 358.476 717.109 358.486C716.634 358.496 716.166 358.599 715.731 358.79C715.296 358.981 714.903 359.255 714.575 359.598V359.577Z",
    fill: "url(#paint8_linear_2067_17058)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M725.12 369.309C719.105 376.928 715.874 386.373 715.963 396.08C716.053 405.787 719.457 415.171 725.612 422.678C726.241 423.404 727.131 423.852 728.089 423.924C729.047 423.996 729.994 423.687 730.724 423.063C731.122 422.718 731.439 422.291 731.654 421.81C731.868 421.33 731.974 420.808 731.965 420.282C731.969 419.434 731.665 418.613 731.109 417.972C726.06 411.759 723.27 404.016 723.197 396.011C723.123 388.006 725.769 380.213 730.703 373.908C731.313 373.168 731.604 372.215 731.511 371.261C731.419 370.306 730.951 369.427 730.211 368.817C729.471 368.207 728.518 367.916 727.564 368.009C726.609 368.101 725.73 368.569 725.12 369.309Z",
    fill: "url(#paint9_linear_2067_17058)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M735.537 379.17C731.647 383.99 729.582 390.028 729.703 396.221C729.824 402.414 732.125 408.366 736.2 413.031C736.675 413.614 737.321 414.034 738.046 414.234C738.772 414.433 739.541 414.401 740.248 414.142C740.954 413.883 741.562 413.41 741.987 412.789C742.411 412.168 742.632 411.43 742.617 410.678C742.62 409.836 742.315 409.023 741.762 408.389C738.777 404.979 737.092 400.625 737.002 396.094C736.912 391.563 738.423 387.145 741.27 383.619C741.81 382.861 742.037 381.924 741.904 381.002C741.77 380.081 741.287 379.246 740.553 378.673C739.82 378.099 738.893 377.831 737.967 377.924C737.04 378.016 736.185 378.463 735.58 379.17H735.537Z",
    fill: "url(#paint10_linear_2067_17058)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6492 359.576C80.2053 368.518 85.3175 382.207 85.2106 396.132C85.1036 410.057 79.7561 423.94 70.8791 432.795C70.5421 433.129 70.1424 433.394 69.7031 433.574C69.2638 433.754 68.7933 433.845 68.3186 433.843C67.8439 433.841 67.3742 433.746 66.9364 433.562C66.4985 433.379 66.1012 433.111 65.7669 432.774C65.4326 432.437 65.168 432.037 64.9882 431.598C64.8083 431.158 64.7168 430.688 64.7188 430.213C64.7208 429.738 64.8162 429.269 64.9997 428.831C65.1832 428.393 65.4512 427.996 65.7883 427.661C73.339 420.153 77.8951 408.41 77.9807 396.09C78.0662 383.769 73.7026 372.197 66.43 364.582C65.7572 363.901 65.38 362.983 65.38 362.026C65.38 361.069 65.7572 360.15 66.43 359.469C66.773 359.122 67.1834 358.847 67.636 358.663C68.0887 358.479 68.5741 358.39 69.0626 358.4C69.5511 358.41 70.0324 358.519 70.4772 358.722C70.9219 358.924 71.3207 359.215 71.6492 359.576Z",
    fill: "url(#paint11_linear_2067_17058)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1255 369.309C67.1418 376.928 70.3713 386.376 70.2779 396.084C70.1845 405.792 66.7739 415.175 60.6122 422.678C59.9874 423.403 59.1007 423.85 58.1463 423.922C57.192 423.995 56.248 423.685 55.5213 423.063C55.1241 422.716 54.8059 422.289 54.5882 421.809C54.3704 421.33 54.2583 420.809 54.2593 420.282C54.2656 419.432 54.5768 418.612 55.1363 417.972C60.1854 411.759 62.9753 404.016 63.0492 396.011C63.123 388.006 60.4764 380.213 55.5427 373.908C54.9329 373.168 54.6421 372.215 54.7343 371.261C54.8266 370.306 55.2943 369.427 56.0347 368.817C56.775 368.207 57.7273 367.916 58.682 368.009C59.6367 368.101 60.5157 368.569 61.1255 369.309Z",
    fill: "url(#paint12_linear_2067_17058)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7083 379.17C54.5928 383.998 56.6532 390.04 56.5281 396.235C56.4029 402.431 54.1002 408.385 50.0238 413.052C49.7206 413.418 49.3478 413.72 48.927 413.941C48.5061 414.162 48.0456 414.298 47.5722 414.339C47.0987 414.381 46.6216 414.329 46.1686 414.185C45.7156 414.041 45.2956 413.808 44.9329 413.501C44.5269 413.157 44.2015 412.727 43.9797 412.243C43.7579 411.759 43.6452 411.232 43.6495 410.699C43.6568 409.859 43.9598 409.049 44.5051 408.41C47.5164 405.014 49.2215 400.658 49.3155 396.12C49.4096 391.582 47.8865 387.158 45.0185 383.64C44.7241 383.268 44.5065 382.84 44.3782 382.383C44.25 381.926 44.2137 381.448 44.2714 380.976C44.329 380.505 44.4796 380.05 44.7143 379.637C44.949 379.224 45.2632 378.862 45.6388 378.571C46.3931 377.985 47.3477 377.719 48.2963 377.831C49.2449 377.943 50.1113 378.424 50.7083 379.17Z",
    fill: "url(#paint13_linear_2067_17058)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M429.7 28.6914C420.737 37.2475 407.069 42.3384 393.123 42.2528C379.176 42.1673 365.358 36.7983 356.481 28.0283C355.803 27.3504 355.422 26.4309 355.422 25.4722C355.422 24.5135 355.803 23.594 356.481 22.9161C357.173 22.2402 358.102 21.8636 359.069 21.868C359.54 21.8677 360.007 21.9622 360.44 22.146C360.874 22.3297 361.266 22.5989 361.593 22.9375C369.101 30.4882 380.845 35.0443 393.165 35.1299C404.758 35.4083 416.025 31.2806 424.694 23.5792C425.387 22.9154 426.314 22.5538 427.273 22.5739C428.231 22.5939 429.143 22.994 429.807 23.6861C430.47 24.3782 430.832 25.3057 430.812 26.2644C430.792 27.2231 430.392 28.1346 429.7 28.7984V28.6914Z",
    fill: "url(#paint14_linear_2067_17058)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M419.903 18.146C412.29 24.1727 402.842 27.4107 393.132 27.3212C383.422 27.2317 374.036 23.8201 366.535 17.654C366.147 17.3541 365.824 16.9783 365.585 16.5495C365.347 16.1207 365.199 15.6479 365.149 15.1599C365.099 14.6719 365.149 14.1789 365.296 13.7109C365.443 13.2429 365.684 12.8097 366.004 12.4376C366.323 12.0656 366.715 11.7626 367.156 11.5469C367.597 11.3312 368.076 11.2075 368.566 11.1832C369.056 11.159 369.546 11.2346 370.006 11.4057C370.466 11.5767 370.886 11.8395 371.241 12.1781C377.453 17.2272 385.196 20.0172 393.201 20.091C401.207 20.1649 409 17.5182 415.304 12.5845C416.048 12.0418 416.971 11.8034 417.885 11.9179C418.799 12.0325 419.634 12.4915 420.221 13.2011C420.808 13.9108 421.102 14.8176 421.043 15.7365C420.984 16.6555 420.576 17.5173 419.903 18.146Z",
    fill: "url(#paint15_linear_2067_17058)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M410.021 7.75042C405.194 11.6293 399.157 13.6864 392.966 13.5612C386.775 13.4361 380.826 11.1367 376.16 7.06593C375.577 6.5908 375.156 5.94553 374.957 5.22004C374.758 4.49456 374.79 3.72502 375.049 3.01868C375.308 2.31234 375.781 1.70441 376.402 1.27962C377.023 0.854819 377.761 0.634322 378.513 0.64887C379.361 0.645419 380.182 0.949382 380.823 1.50448C384.22 4.50706 388.574 6.20489 393.107 6.295C397.64 6.38511 402.058 4.86166 405.572 1.99646C406.329 1.40647 407.29 1.14148 408.242 1.25982C409.195 1.37816 410.062 1.87012 410.652 2.62747C411.242 3.38482 411.507 4.34553 411.388 5.29824C411.27 6.25096 410.778 7.11765 410.021 7.70764V7.75042Z",
    fill: "url(#paint16_linear_2067_17058)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M387.561 726.932C578.007 726.932 732.393 678.665 732.393 619.125C732.393 559.586 578.007 511.319 387.561 511.319C197.116 511.319 42.73 559.586 42.73 619.125C42.73 678.665 197.116 726.932 387.561 726.932Z",
    fill: "url(#paint17_linear_2067_17058)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M387.561 726.932C578.007 726.932 732.393 678.665 732.393 619.125C732.393 559.586 578.007 511.319 387.561 511.319C197.116 511.319 42.73 559.586 42.73 619.125C42.73 678.665 197.116 726.932 387.561 726.932Z",
    fill: "#455A64"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M391.026 703.103C564.543 703.103 705.206 660.382 705.206 607.682C705.206 554.982 564.543 512.26 391.026 512.26C217.51 512.26 76.8472 554.982 76.8472 607.682C76.8472 660.382 217.51 703.103 391.026 703.103Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M391.027 665.285C545.736 665.285 671.153 629.057 671.153 584.366C671.153 539.676 545.736 503.447 391.027 503.447C236.317 503.447 110.9 539.676 110.9 584.366C110.9 629.057 236.317 665.285 391.027 665.285Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M391.027 652.836C532.127 652.836 646.511 620.984 646.511 581.692C646.511 542.401 532.127 510.549 391.027 510.549C249.926 510.549 135.542 542.401 135.542 581.692C135.542 620.984 249.926 652.836 391.027 652.836Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M391.027 652.815C530.26 652.815 643.132 626.144 643.132 593.243C643.132 560.343 530.26 533.672 391.027 533.672C251.793 533.672 138.922 560.343 138.922 593.243C138.922 626.144 251.793 652.815 391.027 652.815Z",
    fill: "#303940",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_2067_17058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.027 608.494C480.348 608.494 552.758 602.384 552.758 594.847C552.758 587.31 480.348 581.201 391.027 581.201C301.705 581.201 229.296 587.31 229.296 594.847C229.296 602.384 301.705 608.494 391.027 608.494Z",
    fill: "black"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.472 677.157C150.708 678.921 150.398 680.714 149.586 682.297C148.773 683.88 147.496 685.177 145.925 686.014C144.355 686.851 142.566 687.187 140.799 686.979C139.032 686.77 137.371 686.026 136.038 684.847C134.706 683.668 133.765 682.109 133.344 680.381C132.922 678.652 133.038 676.835 133.678 675.175C134.317 673.514 135.449 672.089 136.922 671.09C138.394 670.091 140.137 669.566 141.916 669.585C144.051 669.473 146.143 670.204 147.744 671.621C149.344 673.037 150.324 675.025 150.472 677.157Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M266.3 717.777C271.073 717.777 274.942 714.387 274.942 710.205C274.942 706.023 271.073 702.633 266.3 702.633C261.528 702.633 257.659 706.023 257.659 710.205C257.659 714.387 261.528 717.777 266.3 717.777Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M423.112 680.9C423.348 682.664 423.038 684.458 422.225 686.041C421.413 687.624 420.136 688.92 418.565 689.757C416.995 690.594 415.206 690.93 413.439 690.722C411.672 690.513 410.01 689.769 408.678 688.59C407.345 687.411 406.405 685.852 405.983 684.124C405.561 682.395 405.678 680.579 406.318 678.918C406.957 677.258 408.089 675.832 409.561 674.833C411.034 673.834 412.777 673.309 414.556 673.328C416.69 673.216 418.783 673.947 420.383 675.364C421.984 676.78 422.964 678.768 423.112 680.9Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M561.399 710.205C566.172 710.205 570.041 706.815 570.041 702.633C570.041 698.451 566.172 695.061 561.399 695.061C556.627 695.061 552.758 698.451 552.758 702.633C552.758 706.815 556.627 710.205 561.399 710.205Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M656.522 675.617C661.294 675.617 665.163 672.227 665.163 668.045C665.163 663.863 661.294 660.473 656.522 660.473C651.749 660.473 647.88 663.863 647.88 668.045C647.88 672.227 651.749 675.617 656.522 675.617Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M695.238 626.377C693.805 629.115 688.821 629.328 684.072 626.869C679.324 624.409 676.65 620.173 678.083 617.435C679.516 614.698 684.5 614.484 689.249 616.944C693.997 619.403 696.671 623.639 695.238 626.377Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8154 626.377C88.2485 629.115 93.2324 629.328 97.981 626.869C102.73 624.409 105.403 620.173 103.97 617.435C102.537 614.698 97.5532 614.484 92.8046 616.944C88.056 619.403 85.3822 623.639 86.8154 626.377Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M135.136 600.901V527.917",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M182.28 654.12V617.628",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M182.28 608.494V535.511",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M603.474 657.157V584.174",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M559.154 669.82V509.329",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M375.391 686.055V652.601",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M235.092 673.927V592.109",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M484.48 683.895V667.36",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M484.48 662.205V628.452",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M375.391 637.393V619.147",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M603.474 567.447V533.992",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M646.062 625.222V462.528",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M135.136 517.265V477.779",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M531.453 397.309H521.293V424.175H531.453V397.309Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M524.651 197.824H257.209V255.749H524.651V197.824Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M531.453 555.81H521.293V582.676H531.453V555.81Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M259.648 555.81H249.488V582.676H259.648V555.81Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M258.172 241.866H248.012V268.732H258.172V241.866Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M258.172 477.565H248.012V504.431H258.172V477.565Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M258.172 397.138H248.012V424.004H258.172V397.138Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M534.063 241.866H523.903V268.732H534.063V241.866Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M534.063 477.565H523.903V504.431H534.063V477.565Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M258.172 319.363H248.012V346.229H258.172V319.363Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M534.063 319.363H523.903V346.229H534.063V319.363Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M524.651 227H257.209V284.925H524.651V227Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M329.059 241.781H313.787V270.144H329.059V241.781Z",
    fill: "url(#paint18_linear_2067_17058)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M305.637 241.781H290.364V270.144H305.637V241.781Z",
    fill: "url(#paint19_linear_2067_17058)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M282.236 241.781H270.065V270.144H282.236V241.781Z",
    fill: "url(#paint20_linear_2067_17058)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M352.482 241.781H337.209V270.144H352.482V241.781Z",
    fill: "url(#paint21_linear_2067_17058)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M454.363 241.781H360.61V270.144H454.363V241.781Z",
    fill: "url(#paint22_linear_2067_17058)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M479.347 261.866C483.293 261.866 486.491 258.668 486.491 254.722C486.491 250.776 483.293 247.577 479.347 247.577C475.401 247.577 472.203 250.776 472.203 254.722C472.203 258.668 475.401 261.866 479.347 261.866Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M514.491 254.765C514.491 253.346 514.07 251.96 513.282 250.781C512.494 249.602 511.373 248.684 510.063 248.142C508.752 247.601 507.31 247.46 505.92 247.738C504.529 248.016 503.252 248.701 502.251 249.705C501.25 250.71 500.569 251.988 500.295 253.38C500.021 254.771 500.166 256.213 500.711 257.522C501.257 258.831 502.179 259.948 503.36 260.733C504.541 261.518 505.929 261.935 507.347 261.93C509.244 261.925 511.061 261.167 512.4 259.824C513.739 258.481 514.491 256.661 514.491 254.765Z",
    fill: "url(#paint23_linear_2067_17058)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M437.636 261.866C441.582 261.866 444.78 258.668 444.78 254.722C444.78 250.776 441.582 247.577 437.636 247.577C433.69 247.577 430.492 250.776 430.492 254.722C430.492 258.668 433.69 261.866 437.636 261.866Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M514.491 284.925H267.349V304.754H514.491V284.925Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M524.651 304.775H257.209V362.7H524.651V304.775Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M305.637 319.556H290.364V347.919H305.637V319.556Z",
    fill: "url(#paint24_linear_2067_17058)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M352.482 319.556H337.209V347.919H352.482V319.556Z",
    fill: "url(#paint25_linear_2067_17058)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M329.059 319.556H313.787V347.919H329.059V319.556Z",
    fill: "url(#paint26_linear_2067_17058)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M282.236 319.556H270.065V347.919H282.236V319.556Z",
    fill: "url(#paint27_linear_2067_17058)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M454.363 319.556H360.61V347.919H454.363V319.556Z",
    fill: "url(#paint28_linear_2067_17058)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M479.347 339.641C483.293 339.641 486.491 336.442 486.491 332.497C486.491 328.551 483.293 325.352 479.347 325.352C475.401 325.352 472.203 328.551 472.203 332.497C472.203 336.442 475.401 339.641 479.347 339.641Z",
    fill: "url(#paint29_linear_2067_17058)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M514.491 332.497C514.495 331.078 514.078 329.689 513.292 328.508C512.507 327.326 511.388 326.404 510.077 325.859C508.767 325.314 507.325 325.17 505.933 325.446C504.541 325.722 503.262 326.405 502.258 327.408C501.255 328.412 500.572 329.691 500.296 331.083C500.02 332.475 500.164 333.917 500.709 335.227C501.254 336.538 502.176 337.657 503.358 338.442C504.539 339.228 505.928 339.645 507.347 339.641C509.242 339.641 511.059 338.888 512.399 337.548C513.738 336.209 514.491 334.391 514.491 332.497Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M437.636 339.641C441.582 339.641 444.78 336.442 444.78 332.497C444.78 328.551 441.582 325.352 437.636 325.352C433.69 325.352 430.492 328.551 430.492 332.497C430.492 336.442 433.69 339.641 437.636 339.641Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M514.491 362.7H267.349V382.528H514.491V362.7Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M524.651 382.528H257.209V440.453H524.651V382.528Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M329.059 397.309H313.787V425.672H329.059V397.309Z",
    fill: "url(#paint30_linear_2067_17058)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M352.482 397.309H337.209V425.672H352.482V397.309Z",
    fill: "url(#paint31_linear_2067_17058)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M305.637 397.309H290.364V425.672H305.637V397.309Z",
    fill: "url(#paint32_linear_2067_17058)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M454.363 397.309H360.61V425.672H454.363V397.309Z",
    fill: "url(#paint33_linear_2067_17058)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M282.236 397.309H270.065V425.672H282.236V397.309Z",
    fill: "url(#paint34_linear_2067_17058)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M479.347 417.394C483.293 417.394 486.491 414.196 486.491 410.25C486.491 406.304 483.293 403.106 479.347 403.106C475.401 403.106 472.203 406.304 472.203 410.25C472.203 414.196 475.401 417.394 479.347 417.394Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M514.491 410.25C514.491 408.832 514.07 407.446 513.282 406.267C512.494 405.088 511.373 404.169 510.063 403.628C508.752 403.086 507.31 402.945 505.92 403.224C504.529 403.502 503.252 404.186 502.251 405.191C501.25 406.195 500.569 407.474 500.295 408.865C500.021 410.257 500.166 411.698 500.711 413.007C501.257 414.316 502.179 415.434 503.36 416.219C504.541 417.003 505.929 417.42 507.347 417.416C509.244 417.41 511.061 416.653 512.4 415.309C513.739 413.966 514.491 412.147 514.491 410.25Z",
    fill: "url(#paint35_linear_2067_17058)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M437.636 417.394C441.582 417.394 444.78 414.196 444.78 410.25C444.78 406.304 441.582 403.106 437.636 403.106C433.69 403.106 430.492 406.304 430.492 410.25C430.492 414.196 433.69 417.394 437.636 417.394Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M514.491 440.453H267.349V460.282H514.491V440.453Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M524.651 460.303H257.209V518.228H524.651V460.303Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M352.482 475.084H337.209V503.447H352.482V475.084Z",
    fill: "url(#paint36_linear_2067_17058)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M305.637 475.084H290.364V503.447H305.637V475.084Z",
    fill: "url(#paint37_linear_2067_17058)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M329.059 475.084H313.787V503.447H329.059V475.084Z",
    fill: "url(#paint38_linear_2067_17058)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M282.236 475.084H270.065V503.447H282.236V475.084Z",
    fill: "url(#paint39_linear_2067_17058)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M454.363 475.084H360.61V503.447H454.363V475.084Z",
    fill: "url(#paint40_linear_2067_17058)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M479.347 495.169C483.293 495.169 486.491 491.971 486.491 488.025C486.491 484.079 483.293 480.88 479.347 480.88C475.401 480.88 472.203 484.079 472.203 488.025C472.203 491.971 475.401 495.169 479.347 495.169Z",
    fill: "url(#paint41_linear_2067_17058)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M514.491 488.025C514.495 486.606 514.078 485.217 513.292 484.036C512.507 482.854 511.388 481.932 510.077 481.387C508.767 480.842 507.325 480.699 505.933 480.974C504.541 481.25 503.262 481.933 502.258 482.936C501.255 483.94 500.572 485.219 500.296 486.611C500.02 488.003 500.164 489.445 500.709 490.756C501.254 492.066 502.176 493.185 503.358 493.97C504.539 494.756 505.928 495.173 507.347 495.169C509.242 495.169 511.059 494.416 512.399 493.077C513.738 491.737 514.491 489.92 514.491 488.025Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M437.636 495.169C441.582 495.169 444.78 491.971 444.78 488.025C444.78 484.079 441.582 480.88 437.636 480.88C433.69 480.88 430.492 484.079 430.492 488.025C430.492 491.971 433.69 495.169 437.636 495.169Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M514.491 518.228H267.349V538.056H514.491V518.228Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M524.651 538.056H257.209V595.981H524.651V538.056Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M305.637 552.837H290.364V581.201H305.637V552.837Z",
    fill: "url(#paint42_linear_2067_17058)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M329.059 552.837H313.787V581.201H329.059V552.837Z",
    fill: "url(#paint43_linear_2067_17058)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M352.482 552.837H337.209V581.201H352.482V552.837Z",
    fill: "url(#paint44_linear_2067_17058)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M282.236 552.837H270.065V581.201H282.236V552.837Z",
    fill: "url(#paint45_linear_2067_17058)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M454.363 552.837H360.61V581.201H454.363V552.837Z",
    fill: "url(#paint46_linear_2067_17058)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M479.347 572.922C483.293 572.922 486.491 569.724 486.491 565.778C486.491 561.832 483.293 558.634 479.347 558.634C475.401 558.634 472.203 561.832 472.203 565.778C472.203 569.724 475.401 572.922 479.347 572.922Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M514.491 565.778C514.491 564.36 514.07 562.974 513.282 561.795C512.494 560.616 511.373 559.698 510.063 559.156C508.752 558.614 507.31 558.473 505.92 558.752C504.529 559.03 503.252 559.715 502.251 560.719C501.25 561.723 500.569 563.002 500.295 564.393C500.021 565.785 500.166 567.226 500.711 568.535C501.257 569.844 502.179 570.962 503.36 571.747C504.541 572.531 505.929 572.948 507.347 572.944C509.244 572.938 511.061 572.181 512.4 570.838C513.739 569.494 514.491 567.675 514.491 565.778Z",
    fill: "url(#paint47_linear_2067_17058)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M437.636 572.922C441.582 572.922 444.78 569.724 444.78 565.778C444.78 561.832 441.582 558.634 437.636 558.634C433.69 558.634 430.492 561.832 430.492 565.778C430.492 569.724 433.69 572.922 437.636 572.922Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2067_17058",
    x: 200.396,
    y: 552.301,
    width: 381.262,
    height: 85.0939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.45,
    result: "effect1_foregroundBlur_2067_17058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2067_17058",
    x1: 191.864,
    y1: 161.745,
    x2: 192.844,
    y2: 172.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2067_17058",
    x1: 188.615,
    y1: -2.43243,
    x2: 684.488,
    y2: 595.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2067_17058",
    x1: 377.777,
    y1: 43.3354,
    x2: 436.4,
    y2: 94.6522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2067_17058",
    x1: 388.872,
    y1: 113.841,
    x2: 409.093,
    y2: 123.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2067_17058",
    x1: 630.17,
    y1: 330.338,
    x2: 689.466,
    y2: 381.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2067_17058",
    x1: 641.255,
    y1: 401.885,
    x2: 661.47,
    y2: 411.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2067_17058",
    x1: 122.313,
    y1: 331.269,
    x2: 180.937,
    y2: 382.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2067_17058",
    x1: 133.473,
    y1: 401.898,
    x2: 153.686,
    y2: 411.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2067_17058",
    x1: 706.202,
    y1: 348.563,
    x2: 738.047,
    y2: 355.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2067_17058",
    x1: 720.014,
    y1: 360.628,
    x2: 744.748,
    y2: 366.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2067_17058",
    x1: 732.97,
    y1: 373.106,
    x2: 752.355,
    y2: 378.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2067_17058",
    x1: 69.9084,
    y1: 348.467,
    x2: 101.757,
    y2: 355.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2067_17058",
    x1: 58.3163,
    y1: 360.628,
    x2: 83.0726,
    y2: 366.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2067_17058",
    x1: 46.9121,
    y1: 372.995,
    x2: 66.2596,
    y2: 378.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2067_17058",
    x1: 374.514,
    y1: 19.1843,
    x2: 385.777,
    y2: 54.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2067_17058",
    x1: 379.291,
    y1: 9.05356,
    x2: 388.694,
    y2: 36.8501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2067_17058",
    x1: 384.094,
    y1: -1.05241,
    x2: 392.85,
    y2: 20.1128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2067_17058",
    x1: 217.378,
    y1: 482.935,
    x2: 350.999,
    y2: 847.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2067_17058",
    x1: 317.654,
    y1: 238.047,
    x2: 338.304,
    y2: 247.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2067_17058",
    x1: 294.232,
    y1: 238.047,
    x2: 314.881,
    y2: 247.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2067_17058",
    x1: 273.147,
    y1: 238.047,
    x2: 290.721,
    y2: 244.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2067_17058",
    x1: 341.077,
    y1: 238.047,
    x2: 361.726,
    y2: 247.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2067_17058",
    x1: 384.352,
    y1: 238.047,
    x2: 401.49,
    y2: 286.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2067_17058",
    x1: 503.789,
    y1: 245.712,
    x2: 517.368,
    y2: 257.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2067_17058",
    x1: 294.232,
    y1: 315.822,
    x2: 314.881,
    y2: 325.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2067_17058",
    x1: 341.077,
    y1: 315.822,
    x2: 361.726,
    y2: 325.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2067_17058",
    x1: 317.654,
    y1: 315.822,
    x2: 338.304,
    y2: 325.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2067_17058",
    x1: 273.147,
    y1: 315.822,
    x2: 290.721,
    y2: 322.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2067_17058",
    x1: 384.352,
    y1: 315.822,
    x2: 401.49,
    y2: 364.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2067_17058",
    x1: 475.821,
    y1: 323.471,
    x2: 489.359,
    y2: 335.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2067_17058",
    x1: 317.654,
    y1: 393.575,
    x2: 338.304,
    y2: 403.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2067_17058",
    x1: 341.077,
    y1: 393.575,
    x2: 361.726,
    y2: 403.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2067_17058",
    x1: 294.232,
    y1: 393.575,
    x2: 314.881,
    y2: 403.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2067_17058",
    x1: 384.352,
    y1: 393.575,
    x2: 401.49,
    y2: 441.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2067_17058",
    x1: 273.147,
    y1: 393.575,
    x2: 290.721,
    y2: 400.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2067_17058",
    x1: 503.789,
    y1: 401.198,
    x2: 517.368,
    y2: 412.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2067_17058",
    x1: 341.077,
    y1: 471.35,
    x2: 361.726,
    y2: 480.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2067_17058",
    x1: 294.232,
    y1: 471.35,
    x2: 314.881,
    y2: 480.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2067_17058",
    x1: 317.654,
    y1: 471.35,
    x2: 338.304,
    y2: 480.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2067_17058",
    x1: 273.147,
    y1: 471.35,
    x2: 290.721,
    y2: 477.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2067_17058",
    x1: 384.352,
    y1: 471.35,
    x2: 401.49,
    y2: 519.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2067_17058",
    x1: 475.821,
    y1: 479,
    x2: 489.359,
    y2: 490.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2067_17058",
    x1: 294.232,
    y1: 549.103,
    x2: 314.881,
    y2: 558.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2067_17058",
    x1: 317.654,
    y1: 549.103,
    x2: 338.304,
    y2: 558.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2067_17058",
    x1: 341.077,
    y1: 549.103,
    x2: 361.726,
    y2: 558.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2067_17058",
    x1: 273.147,
    y1: 549.103,
    x2: 290.721,
    y2: 555.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2067_17058",
    x1: 384.352,
    y1: 549.103,
    x2: 401.49,
    y2: 597.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2067_17058",
    x1: 503.789,
    y1: 556.726,
    x2: 517.368,
    y2: 568.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage4);
export default __webpack_public_path__ + "static/media/Image 4.478aae4cdc2332bf3b4a8aaf3394e3f6.svg";
export { ForwardRef as ReactComponent };